export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/notes-icon.svg?4dd3c9de2b63bbe42664f7d78570473a";